@let borough = parserBorough();

<homey-page-title-layout>
  {{ 'apartment.list.titleBase' | transloco }}{{ postFix() }}
</homey-page-title-layout>
<p class="mb-8">
  {{ 'apartment.list.description' | transloco : { location: location() } }}
</p>

<div class="sr-only">
  <a routerLink="/apartments/boroughs/manhattan">
    {{ 'apartment.list.links.manhattan' | transloco }}
  </a>
  <a routerLink="/apartments/boroughs/bronx">
    {{ 'apartment.list.links.bronx' | transloco }}
  </a>
  <a routerLink="/apartments/boroughs/brooklyn">
    {{ 'apartment.list.links.brooklyn' | transloco }}
  </a>
  <a routerLink="/apartments/boroughs/queens">
    {{ 'apartment.list.links.queens' | transloco }}
  </a>
  <a routerLink="/apartments/boroughs/staten-island">
    {{ 'apartment.list.links.statenIsland' | transloco }}
  </a>
</div>

<p-selectButton
  id="household-size"
  [unselectable]="false"
  [allowEmpty]="false"
  [ngModel]="borough"
  (ngModelChange)="onBoroughChange($event)"
  [styleClass]="'w-full h-12 custom-toggle-button'"
  [options]="boroughOptions"
  optionLabel="label" optionValue="value"/>

<homey-lottery-list
  class="mt-6"
  ngSkipHydration
  [emptyState]="{
    title: ('apartment.list.empty.open.title' | transloco : { place: (borough === 'all' ? 'NYC' : (borough | boroughToText)) }),
    description: ('apartment.list.empty.open.description' | transloco)
  }"
  [lotteries]="openLotteries()"
>
  <ng-template [lotteryListItem]="openLotteries()" let-lottery>
    <homey-lottery-list-item [apartment]="lottery"
                             [baseRoute]="baseRoute()"
                             [showNeighbourhoodAndBorough]="false">
      <div>
        <p class="text-muted-color">{{ lottery | apartmentAddress }}</p>
        <p class="text-muted-color">
          {{ 'apartment.list.closes' | transloco }} {{ lottery.endDate | date }}
        </p>
      </div>
    </homey-lottery-list-item>
  </ng-template>
</homey-lottery-list>

<div class="mt-8">
  <p-divider [dt]="whiteDividerDt">
    <span class="text-muted-color">{{ 'apartment.list.closedLotteries' | transloco }}</span></p-divider>
</div>
<homey-lottery-list class="mt-8" ngSkipHydration
                    [lotteries]="closedLotteries()">
  <ng-template [lotteryListItem]="closedLotteries()" let-lottery>
    <homey-lottery-list-item class="opacity-70"
                             [baseRoute]="baseRoute()"
                             [apartment]="lottery"
                             [showNeighbourhoodAndBorough]="false">
      <div>
        <p class="text-muted-color">{{ lottery | apartmentAddress }}</p>
        <p class="text-muted-color">
          {{ 'apartment.list.closedSince' | transloco : { date: (lottery.endDate | date) } }}
        </p>
      </div>
    </homey-lottery-list-item>
  </ng-template>
</homey-lottery-list>

<homey-lotteries-and-footer/>
